import { PhosphorBellButton, PhosphorEnvelopeSimpleButton, PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import moment from "moment";
import React from "react";
import { getTimeBeforeShowLabel } from "userTask/beforeShowLabelHelper";
import { DeleteDialog } from "../../components";
import { UserAvatar } from "../../components/Atoms/Avatar";
import CollapsiblePreview from "../../components/CollapsiblePreview/CollapsiblePreviews";
import VisibleToExternalIcon from "../../components/VisibleToExternal/VisibleToExternalIcon";
import { formatShortDateWithTimeZone } from "../../utilities";
import TaskFull from "./TaskFull";
import TaskPreview from "./TaskPreview";

interface Props {
  canDelete: boolean
  canEdit: boolean
  task: server.dto.UserTask
  onDeleted: () => void
  onEdit: (task: server.dto.UserTask) => void
  config: server.dto.LinkedUserTaskPanelConfig

  onReminderPopupChanged: (task: server.dto.UserTask, reminderPopup: boolean) => void
  onReminderEmailChanged: (task: server.dto.UserTask, reminderEmail: boolean) => void
}

const UserTaskRowCard = ({ task, onDeleted, onEdit, canDelete, canEdit, config, onReminderEmailChanged, onReminderPopupChanged }: Props) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  let collapsible = false;
  if (task.body) {
    const brIndex = task.body.indexOf("<br");
    if (brIndex > -1 || task.body.length > 100) {
      collapsible = true;
    }
  }

  const isInternalUser = site.currentEnvironment.type === "internal";

  const togglePopupReminder = async () => {
    onReminderPopupChanged(task, !task.reminderPopup);
    return window.CoreApi.UserTask.SetTaskReminderPopup({
      state: !task.reminderPopup,
      userTaskId: task.userTaskId
    });
  };

  const toggleEmailReminder = async () => {
    onReminderEmailChanged(task, !task.reminderEmail);
    return window.CoreApi.UserTask.SetTaskReminderEmail({
      state: !task.reminderEmail,
      userTaskId: task.userTaskId
    });
  };

  const deleteTask = async () => {
    await window.CoreApi.UserTask.DeleteUserTask(task.userTaskId);
    onDeleted();
  };

  return <div>
    <div>
      <UserAvatar user={task.assignedTo} />
    </div>

    <div className="no-wrap" style={{ width: 150 }}>
      <div>{task.assignedTo.fullName}</div>
      <div className="text-sublabel">
        {task.deadlineType === "absolute" && formatShortDateWithTimeZone(moment.utc(task.deadlineSource))}
        {task.deadlineType === "relativeToShowDate" && getTimeBeforeShowLabel(task.deadlineOffsetInDays)}
      </div>
      <div className="text-sublabel">{RESX.RecordInformation.by} {task.createdBy.fullName}</div>
      {isInternalUser && config.showVisibleToExternalCheckbox && <VisibleToExternalIcon visibleToExternal={task.visibleToExternal} />}
    </div>

    <CollapsiblePreview
      preview={<TaskPreview task={task} />}
      fullView={<TaskFull task={task} />}
      onlyShowFullView={!collapsible}
    />

    {config.showInputReminders && <>
      {canEdit && <>
        <PhosphorBellButton
          layout="in-square"
          onClick={togglePopupReminder}
          iconColor={task.reminderPopup ? null : "gray"}
          selectedStyle={task.reminderPopup ? "blue-line" : null}
        />
        <PhosphorEnvelopeSimpleButton
          layout="in-square"
          onClick={toggleEmailReminder}
          iconColor={task.reminderEmail ? null : "gray"}
          selectedStyle={task.reminderEmail ? "blue-line" : null}
        />
      </>}
    </>}

    {canDelete && <PhosphorTrashButton
      layout="in-square"
      onClick={() => { setIsDeleting(true); }}
    />}

    {canEdit && <PhosphorPencilButton
      layout="in-square"
      onClick={() => { onEdit(task); }}
    />}

    <DeleteDialog
      isOpen={isDeleting}
      onDelete={deleteTask}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setIsDeleting(false); }}
    />
  </div >;
};

export default UserTaskRowCard;